export default "__VITE_ASSET__CHs$dLbx__"